import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IDataModelEntitiesProps } from './IDataModelEntitiesProps';

/**
 * «Сутності · типи записів модуля» (прототип v4 mdEntRows): картка з рядками-кнопками — назва й опис сутності, бейдж виду (основний —
 * акцентний, дочірній — сірий, довідник — фіолетовий) і кількість атрибутів; вибрана — акцентне тло з лінією ліворуч.
 */
export function DataModelEntities({ entities, selected, onSelect }: IDataModelEntitiesProps) {
  const { t } = useTranslation();
  return (
    <section className="dm-section">
      <div className="dm-label"><span className="dm-label__title">{t('modDesign.model.entities')}</span><span className="dm-label__sub">{t('modDesign.model.entitiesSub')}</span></div>
      <div className="dm-card">
        {entities.map((e, i) => (
          <button key={e.key} type="button" className={cx('dm-ent', i === selected && 'is-on')} aria-pressed={i === selected} onClick={() => onSelect(i)}>
            <span className="dm-ent__text"><strong>{e.name}</strong><span title={e.description}>{e.description}</span></span>
            <span className={`dm-kind is-${e.kind}`}>{t(`modDesign.model.kinds.${e.kind}`)}</span>
            <span className="dm-ent__n" title={t('modDesign.model.attrsTip')}>{e.attrs.length}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
